/**
 * SuperAdminGuard - Route guard for super-admin only pages
 * Redirects non-super-admins to dashboard
 */
import { Navigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useSession } from "../lib/auth";

export function SuperAdminGuard({ children }: { children: React.ReactNode }) {
  const { isPending, isSuperAdmin, isAuthenticated } = useSession();

  if (isPending) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
